<button mat-flat-button (click)="clickedButton($event)" [disabled]="spinnerEnabled" [color]="buttonColor" [type]="type">
  <ng-template [ngIf]="!spinnerEnabled">
    <ng-content></ng-content>
  </ng-template>
  <mat-spinner *ngIf="spinnerEnabled" diameter="30" style="margin: 0 auto;" [color]="spinnerColor"></mat-spinner>
</button>
